export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const SIGN_OFF = 'SIGN_OFF';
export const GET_USER = 'GET_USER';
export const RESET_PWD = 'RESET_PWD';

export const NEW_USER_SUCCESS = 'NEW_USER_SUCCESS';
export const NEW_USER_ERROR = 'NEW_USER_ERROR';

export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';

export const FORM_PROJECT = 'FORM_PROJECT';
export const GET_PROJECTS = 'GET_PROJECTS';
export const ADDING_PROJECT = 'ADDING_PROJECT';
export const ACTIVE_PROJECT = 'ACTIVE_PROJECT';
export const DELATE_PROJECT = 'DELATE_PROJECT';

export const TASKS_PROJECT = 'TASKS_PROJECT';
export const ADDING_TASK = 'ADDING_TASK';
export const VALIDATE_TASK = 'VALIDATE_TASK';
export const DELATE_TASK = 'DELATE_TASK';
export const SELECT_TASK = 'SELECT_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';


